import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/lib/Overlay';
import Popover from 'react-bootstrap/lib/Popover';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Avatar from '../avatar';
import SearchBar from '../searchBar';
import Logo from '../logo';
import AppConfig from '../../config/appConfig';
import './styles.css';
import {
  getCommunityInitials,
  sortCommunitiesByName
} from './communityOptions';
import {
  allProfileTypes,
  readableAllProfileTypes
} from '../../constants/profileTypes';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      target: null,
      showProfile: false
    };
  }

  handleProfileClick = e => {
    this.setState({
      target: e.target,
      showProfile: !this.state.showProfile
    });
  };

  handleCommunitySelection = community => {
    const { onCommunitySelection } = this.props;
    return () => {
      onCommunitySelection(community);
    };
  };

  handleSessionModeSelection = sessionType => {
    const { onSessionModeSelection } = this.props;
    return () => {
      onSessionModeSelection(sessionType);
    };
  };

  renderCommunityBadge = community => (
    <span className="kv-header__community-badge" aria-hidden="true">
      {getCommunityInitials(community?.name)}
    </span>
  );

  renderCommunityLabel = community => {
    const { supportToolsEnabled } = this.props;
    return (
      <span className="kv-header__community-label">
        {this.renderCommunityBadge(community)}
        <span className="kv-header__community-text">
          <span className="kv-header__community-name">{community?.name}</span>
          {supportToolsEnabled && community?.id ? (
            <span className="kv-header__community-id">{community.id}</span>
          ) : null}
        </span>
      </span>
    );
  };

  renderCommunityOption = (community, currentCommunity) => {
    return (
      <MenuItem
        key={community.id}
        active={community.id === currentCommunity.id}
        onClick={this.handleCommunitySelection(community)}
      >
        {this.renderCommunityLabel(community)}
      </MenuItem>
    );
  };

  renderCommunitiesDropdown = (communities, currentCommunity) => {
    if (communities.length <= 1) {
      return <p>{this.renderCommunityLabel(currentCommunity)}</p>;
    } else {
      return (
        <DropdownButton
          bsStyle={'default'}
          title={this.renderCommunityLabel(currentCommunity)}
          id={'communities-dropdown'}
        >
          {sortCommunitiesByName(communities).map(community => {
            return this.renderCommunityOption(community, currentCommunity);
          })}
        </DropdownButton>
      );
    }
  };

  renderModeOption = (mode, sessionType) => {
    return (
      <MenuItem
        key={mode}
        active={mode === sessionType}
        onClick={this.handleSessionModeSelection(mode)}
      >
        {readableAllProfileTypes[mode]}
      </MenuItem>
    );
  };

  renderSessionModeDropdown = () => {
    const { canSwitchMode, availableSessionModes, sessionType } = this.props;

    if (!canSwitchMode) {
      return null;
    }

    return (
      <article className="kv-header__mode">
        <DropdownButton
          bsStyle={'default'}
          title={readableAllProfileTypes[sessionType]}
          id={'session-mode-dropdown'}
        >
          {availableSessionModes.map(mode =>
            this.renderModeOption(mode, sessionType)
          )}
        </DropdownButton>
      </article>
    );
  };

  render() {
    const {
      communities,
      currentCommunity,
      avatar,
      userName,
      onLogOff,
      sessionType,
      canSwitchMode
    } = this.props;

    const search =
      sessionType === allProfileTypes.ADMIN ? (
        <SearchBar />
      ) : canSwitchMode ? null : (
        readableAllProfileTypes[sessionType]
      );

    return (
      <section className="kv-header">
        <div className="kv-header__logo">
          <Logo />
        </div>
        <article className="kv-header__search">{search}</article>
        {this.renderSessionModeDropdown()}
        <article className="kv-header__community">
          {this.renderCommunitiesDropdown(communities, currentCommunity)}
        </article>
        <article
          className="kv-header__profile"
          onClick={this.handleProfileClick}
        >
          <Avatar uri={AppConfig.getS3BucketUrlForResource(avatar)} />
          <span className="caret" />
        </article>
        <Overlay
          show={this.state.showProfile}
          target={this.state.target}
          placement="bottom"
          container={this}
          containerPadding={20}
        >
          <Popover id="popover-contained" title={userName}>
            <a
              href="/"
              className="kv-header__profile__logoff"
              onClick={onLogOff}
            >
              Cerrar Sesión
            </a>
          </Popover>
        </Overlay>
      </section>
    );
  }
}

Header.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object),
  currentCommunity: PropTypes.object,
  onCommunitySelection: PropTypes.func,
  avatar: PropTypes.string,
  userName: PropTypes.string,
  onLogOff: PropTypes.func,
  sessionType: PropTypes.string,
  availableSessionModes: PropTypes.arrayOf(PropTypes.string),
  canSwitchMode: PropTypes.bool,
  onSessionModeSelection: PropTypes.func,
  supportToolsEnabled: PropTypes.bool
};

Header.defaultProps = {
  communities: [],
  currentCommunity: {},
  avatar: null,
  userName: '',
  availableSessionModes: [],
  canSwitchMode: false,
  onSessionModeSelection: () => {},
  supportToolsEnabled: false
};

export default Header;
